export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export const fmtDate = (d) =>
    d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const isoFromDMY = (s) => {
    const m = String(s || '').match(/^(\d{2})-(\d{2})-(\d{4})$/);
    return m ? `${m[3]}-${m[2]}-${m[1]}` : (s || '');
};

// The API sends dd-MM-yyyy with an optional time, which JS can't parse natively
// (and building from parts keeps it local instead of UTC midnight).
export const parseApiDate = (v) => {
    if (!v) return null;
    if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
    const s = String(v).trim();
    const dmy = s.match(/^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
    if (dmy) {
        const [, d, mo, y, hh = 0, mi = 0, ss = 0] = dmy;
        return new Date(+y, +mo - 1, +d, +hh, +mi, +ss);
    }
    const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
    if (ymd) {
        const [, y, mo, d, hh = 0, mi = 0, ss = 0] = ymd;
        return new Date(+y, +mo - 1, +d, +hh, +mi, +ss);
    }
    const t = new Date(s);
    return Number.isNaN(t.getTime()) ? null : t;
};

export const fmtClockTime = (v) => {
    const d = parseApiDate(v);
    return d ? d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }) : '';
};

export const fmtDayMon = (v) => {
    const d = parseApiDate(v);
    return d ? d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }) : '';
};

export const fmtMinutes = (mins) => {
    if (!Number.isFinite(mins) || mins < 0) return null;
    if (mins < 1) return '<1m';
    const h = Math.floor(mins / 60);
    const m = Math.round(mins % 60);
    return h ? `${h}h ${m}m` : `${m}m`;
};

export const fmtDayDate = (d) => {
    const iso = isoFromDMY(d);
    if (!iso) return '—';
    const t = new Date(iso);
    return Number.isNaN(t.getTime())
        ? String(d)
        : t.toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' });
};

export const cleanName = (n = '') =>
    String(n).split(/\s+/).filter((w) => w && w !== '-' && w !== '–').join(' ').trim();

export const joinName = (first, last) => cleanName(`${first || ''} ${last || ''}`);

export const initialsFromName = (n = '') =>
    cleanName(n).split(/\s+/).map((w) => w[0]).filter(Boolean).join('').slice(0, 2).toUpperCase();

export const PALETTE = ['#7C5CFC', '#0EA5E9', '#F59E0B', '#16A34A', '#E11D48', '#6246E0', '#0891B2'];

export const paletteColor = (s = '') => PALETTE[(s.charCodeAt(0) || 0) % PALETTE.length];

// Avatars sit in dense lists where a wall of saturated fills shouts over the
// content. Each entry is a soft tint with the deep tone of the same hue for the
// initials, so names still read apart at a glance without the vibrancy.
export const AVATAR_TONES = [
    { bgcolor: '#EDE9FE', color: '#6D28D9' },
    { bgcolor: '#E0F2FE', color: '#0369A1' },
    { bgcolor: '#FEF3C7', color: '#B45309' },
    { bgcolor: '#DCFCE7', color: '#15803D' },
    { bgcolor: '#FFE4E6', color: '#BE123C' },
    { bgcolor: '#E0E7FF', color: '#4338CA' },
    { bgcolor: '#CCFBF1', color: '#0F766E' },
    { bgcolor: '#FFEDD5', color: '#C2410C' },
];

// Spread into an Avatar's sx — it sets both the fill and the initials colour.
export const avatarTone = (s = '') => {
    const key = String(s || '');
    const code = (key.charCodeAt(0) || 0) + (key.charCodeAt(1) || 0);
    return AVATAR_TONES[code % AVATAR_TONES.length];
};

// Time spent at THIS company only: from the date of joining to today (or to the day they left, for an inactive
// employee). Earlier jobs are never counted. Returns e.g. "1 yr 2 mo", "8 mo", "Less than a month", or "" with no joining date.
export const companyExperience = (joined, status, left) => {
    const from = parseApiDate(joined);
    if (!from) return '';
    const inactive = status != null && String(status).toLowerCase() !== 'active';
    const to = (inactive && parseApiDate(left)) || new Date();
    if (to < from) return 'Not joined yet';
    let months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
    if (to.getDate() < from.getDate()) months -= 1;
    if (months < 1) return 'Less than a month';
    const y = Math.floor(months / 12);
    const m = months % 12;
    return [y ? `${y} yr${y > 1 ? 's' : ''}` : '', m ? `${m} mo` : ''].filter(Boolean).join(' ');
};
